import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Award, Users, GraduationCap, Stethoscope } from 'lucide-react';
import nutricionistaImage from '../../Images/Sobremi.jpeg';
import ServicesModal from '../ServicesModal/ServicesModal';
import './Sobremi.css';

const Sobremi = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="sobremi-container">
      <div className="sobremi-pattern"></div>

      <div className="sobremi-content">
        {/* Hero Section */}
        <motion.div
          className="sobremi-hero"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="sobremi-title">
            Conoce a tu <span className="highlight">Nutricionista</span>
          </h2>
          <p className="sobremi-subtitle">
            Especialista en nutrición clínica, deportiva y cambio de hábitos saludables
          </p>
        </motion.div>

        {/* Profile Section */}
        <motion.div
          className="profile-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="profile-content">
            <div className="profile-grid">
              <motion.div
                className="profile-image-container"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
              >
                <div className="image-overlay"></div>
                <img
                  src={nutricionistaImage}
                  alt="Nutricionista Mayra Alejandra Martell"
                  className="profile-image"
                />
                <div className="image-decoration"></div>
              </motion.div>

              <div className="profile-info">
                <h2>Nut. Mayra Alejandra Martell</h2>
                <p className="profile-description">
                  ¡Hola! Soy Mayra Martell Llantoy, Nutricionista Colegiada. Soy especialista en nutrición y bienestar, apasionada por ayudar a las personas a transformar su relación con la comida y mejorar su calidad de vida. Con más de 5 años de experiencia en control de peso, nutrición deportiva y salud digestiva, me especializo en diseñar planes personalizados que se adapten a tus objetivos y estilo de vida. Creo que la nutrición es mucho más que contar calorías: es un acto de amor propio que transforma tu bienestar y felicidad.
                  <br /><br />
                  Te acompaño a construir hábitos sostenibles que te permitan sentirte mejor, prevenir enfermedades y alcanzar tus metas. ¡Demos juntos el primer paso hacia una vida más saludable!
                  <br /><br />
                </p>
                <div className="credentials">
                  <span className="credential-badge">Nutricionista Colegiada</span>
                  <span className="credential-badge">Nutrición Clínica</span>
                  <span className="credential-badge">Nutricional Deportiva</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Expertise Section */}
        <motion.section
          className="expertise-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <h2 className="section-title">Experiencia y Especialización</h2>
          <div className="expertise-grid">
            <motion.div
              className="expertise-card"
              whileHover={{ scale: 1.05 }}
            >
              <GraduationCap className="expertise-icon" />
              <h3>Formación Académica</h3>
              <p>Título profesional en Nutrición Humana , Serums, Isak y especializaciones en nutrición clínica y deportiva</p>
            </motion.div>

            <motion.div
              className="expertise-card"
              whileHover={{ scale: 1.05 }}
            >
              <Award className="expertise-icon" />
              <h3>Certificaciones</h3>
              <p>Certificaciones internacionales en asesoramiento nutricional y manejo de patologías</p>
            </motion.div>

            <motion.div
              className="expertise-card"
              whileHover={{ scale: 1.05 }}
            >
              <Users className="expertise-icon" />
              <h3>Experiencia</h3>
              <p>Más de 500 pacientes satisfechos y casos de éxito documentados</p>
            </motion.div>

            <motion.div
              className="expertise-card"
              whileHover={{ scale: 1.05 }}
            >
              <Stethoscope className="expertise-icon" />
              <h3>Especialidades</h3>
              <p>Nutrición clínica, deportiva, pérdida de peso, nutrición maternal y pediátrica</p>
            </motion.div>
          </div>
        </motion.section>

        {/* Call to Action */}
        <motion.div
          className="cta-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          <h2>¿Listo para transformar tu salud?</h2>
          <p>Agenda una consulta y comienza tu camino hacia una vida más saludable</p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cta-button"
            onClick={handleOpenModal}
          >
            Reserva tu Cita
          </motion.button>
        </motion.div>
      </div>

      {/* Services Modal */}
      {isModalOpen && (
        <ServicesModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Sobremi;